import { useSelector } from 'react-redux';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { pluralize } from '@r1-frontend/shared/helpers/pluralize';
import { bonusPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { IHintProps } from '~/src/features/payments-abn/components/InfoHint';
import { TState } from '~/src/store';

export const useSbpHint = () => {
    const { bonusesInfo: { isUseBonuses, amount, result: bonusesPaymentResult }, result: connectionResult } = useSelector((state: TState) => state.seasonTicketPayment);

    const isTablet = useMatchMediaByWidth(wideBreakpoints.tablet);

    const getSbpHintByBonusesPaymentResult = (): IHintProps => {
        switch (bonusesPaymentResult) {
            case 'success':
                return {
                    hintType: 'info',
                    hintMessage: `Списали ${amount} ${pluralize(amount, bonusPluralize)} с вашего счета и подключили абонемент.\n` +
                        'Осталось пополнить баланс по инструкции ниже. Абонемент заработает, когда на балансе будет достаточно денег.',
                };
            case 'error':
                return {
                    hintType: 'error',
                    hintMessage: 'Не удалось списать бонусы. Попробуйте снова.',
                };
            case 'none':
            default: {
                const firstAction = isTablet ? '«Оплатить»' : '«Показать QR-код»';
                const nextAction = isTablet ? 'вы подтвердите платёж в мобильном приложении вашего банка' : 'отсканируете его';

                return {
                    hintType: 'info',
                    hintMessage: `Когда вы нажмёте ${firstAction}, сначала мы спишем бонусы, а когда ${nextAction}, спишем и деньги.`,
                };
            }
        }
    };

    const getSbpHint = (): IHintProps | null => {
        return (!isUseBonuses && connectionResult === 'success')
            ? {
                hintType: 'success',
                hintMessage: 'Абонемент подключён.\n' +
                    'Осталось пополнить баланс по инструкции ниже. Абонемент заработает, когда на балансе будет достаточно денег.',
            }
            : null;
    };

    return { getSbpHintByBonusesPaymentResult, getSbpHint };
};
